"use client";

import React, { useEffect, useState } from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi } from "@/components/ui/carousel";
const destinations = [{
  name: "Santorini, Görögország",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/santorini_destination.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/santorini_destination.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/santorini_destination.png-wvc-sizes"
}, {
  name: "Maldiv-szigetek",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/maldives_resort.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/maldives_resort.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/maldives_resort.png-wvc-sizes"
}, {
  name: "Párizs, Franciaország",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/paris_cityscape.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/paris_cityscape.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/paris_cityscape.png-wvc-sizes"
}, {
  name: "Bali, Indonézia",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/bali_temple.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/bali_temple.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/bali_temple.png-wvc-sizes"
}, {
  name: "Amalfi-part, Olaszország",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/amalfi_coast.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/amalfi_coast.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/amalfi_coast.png-wvc-sizes"
}, {
  name: "Zermatt, Svájc",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/zermatt_mountains.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/zermatt_mountains.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/zermatt_mountains.png-wvc-sizes"
}, {
  name: "Aspen, USA",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/aspen_snow_peaks.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/aspen_snow_peaks.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/aspen_snow_peaks.png-wvc-sizes"
}, {
  name: "Dolomitok, Olaszország",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/dolomites_landscape.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/dolomites_landscape.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/dolomites_landscape.png-wvc-sizes"
}];
export default function LuxuryAmenitiesOverview() {
  const [api, setApi] = useState<CarouselApi>();
  useEffect(() => {
    if (!api) return;
    const intervalId = setInterval(() => {
      api.scrollNext();
    }, 5000);
    return () => clearInterval(intervalId);
  }, [api]);
  return <section data-section-id="246992" id="taxibookingwidget" className="bg-background text-foreground py-20 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="relative w-full max-w-5xl mx-auto">
          <Carousel setApi={setApi} opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {destinations.map((destination, index) => <CarouselItem key={index} data-index={index === 0 ? 0 : undefined} className="md:basis-1/2 lg:basis-1/3 pl-4">
                  <div className="relative group overflow-hidden rounded-lg shadow-xl border border-border aspect-[4/5]">
                    <img src={destination.src} data-wvc-srcset={destination.srcset} data-wvc-sizes={destination.sizes} alt={destination.name} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                    <div className="absolute inset-0 bg-linear-to-t from-black/80 via-black/20 to-transparent flex items-end p-6">
                      <div className="backdrop-blur-md bg-white/10 border border-white/20 p-4 rounded-lg w-full">
                        <h3 className="font-serif text-xl md:text-2xl text-white font-semibold tracking-tight">
                          {destination.name}
                        </h3>
                        <p className="font-sans text-sm text-white/80 mt-1">
                          Fedezze fel a luxust
                        </p>
                      </div>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <div className="hidden md:block">
              <CarouselPrevious className="left-[-48px] bg-primary text-primary-foreground hover:bg-primary/90 border-none shadow-lg" />
              <CarouselNext className="right-[-48px] bg-primary text-primary-foreground hover:bg-primary/90 border-none shadow-lg" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}